import * as React from "react"

function SvgComponent(props) {
    return (
        <svg
            viewBox="0 0 84 84"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M49.859 41.377a7.482 7.482 0 11-14.963 0 7.482 7.482 0 0114.963 0z"
                fill="#FCFFB0"
                stroke="#F8C478"
                strokeWidth={4}
            />
            <g
                filter="url(#prefix__filter0_d)"
                fill="#1A98FF"
                stroke="#1A98FF"
                strokeWidth={2}
            >
                <path d="M23.268 38.836H11l.049-.489c1.417-14.662 13-26.49 27.614-28.249l.538-.049v12.317l-.391.097c-8.016 1.515-14.223 7.918-15.445 15.982l-.097.391zm-11.193-.977h10.362c1.417-8.162 7.673-14.614 15.786-16.324V11.173C24.538 13.03 13.64 24.125 12.075 37.86zM73.706 38.836H61.44l-.05-.391c-1.27-8.309-7.672-14.76-15.981-16.08l-.391-.049V10l.537.049c14.858 1.515 26.686 13.392 28.152 28.25v.537zm-11.437-.978h10.362C71.018 23.88 59.923 12.737 45.994 11.075v10.362C54.352 23 60.852 29.5 62.27 37.858zM39.2 72.657l-.537-.049c-14.418-1.71-25.708-12.952-27.516-27.37l-.05-.537h12.317l.098.39c1.515 7.625 7.673 13.735 15.298 15.2l.39.099v12.267zM12.174 45.63c1.906 13.538 12.512 24.046 26.05 25.903v-10.41c-7.722-1.613-13.929-7.771-15.59-15.493h-10.46zM45.017 72.706V60.438l.39-.049c7.919-1.27 14.272-7.428 15.836-15.297l.098-.391h12.316l-.049.538c-1.76 14.417-13.587 25.952-28.054 27.418l-.537.049zm.977-11.486v10.362c13.587-1.613 24.633-12.414 26.54-25.952H62.122c-1.71 7.966-8.113 14.173-16.129 15.59z" />
            </g>
            <defs>
                <filter
                    id="prefix__filter0_d"
                    x={0.895}
                    y={0.905}
                    width={82.857}
                    height={82.896}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    />
                    <feOffset dy={1} />
                    <feGaussianBlur stdDeviation={4.5} />
                    <feColorMatrix values="0 0 0 0 0.101961 0 0 0 0 0.596078 0 0 0 0 1 0 0 0 0.61 0" />
                    <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                </filter>
            </defs>
        </svg>
    )
}

export default SvgComponent
